import {useEffect, useState} from 'react';

const BASE = process.env.REACT_APP_AWP_API_URL || 'https://awp.minsky.ai';

function authHeaders() {
    const token = localStorage.getItem('access_token');
    return token ? {'Authorization': `Bearer ${token}`} : {};
}

/**
 * Fetch source-document mentions for a KB entity.
 *
 * Each mention is a source document where the NER pipeline found this entity,
 * optionally linked to one or more reports that used the document as a source.
 *
 * @param {string} entityId  Wikidata Q-number (e.g. "Q2283") or numeric entity_id.
 * @returns {{ mentions: Array, loading: boolean, error: Error|null }}
 */
export function useEntityMentions(entityId) {
    const [mentions, setMentions] = useState([]);
    const [loading, setLoading] = useState(!!entityId);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!entityId) {
            setMentions([]);
            setLoading(false);
            return;
        }

        let cancelled = false;
        setLoading(true);
        setError(null);

        fetch(`${BASE}/api/entities/${encodeURIComponent(entityId)}/mentions`, {
            headers: authHeaders(),
        })
            .then(r => r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`)))
            .then(data => {
                if (!cancelled) {
                    setMentions(Array.isArray(data.mentions) ? data.mentions : []);
                    setLoading(false);
                }
            })
            .catch(err => {
                if (!cancelled) {
                    setError(err);
                    setLoading(false);
                }
            });

        return () => { cancelled = true; };
    }, [entityId]);

    return {mentions, loading, error};
}
